var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpansionPanel = void 0;
var ExpansionPanel_1 = __importDefault(require("./ExpansionPanel"));
exports.ExpansionPanel = ExpansionPanel_1.default;
exports.default = ExpansionPanel_1.default;
//# sourceMappingURL=index.js.map